import { Machine } from "./Machine";

export const statusCodes = {
    Available: 1,
    Notification: 2,
    Action: 3,
    OutOfService: 4,
    Ping: 5,
}


export class MachineStatus {
    idstatus: number;
    cod_status: number;
    notification_code: number;
    notification_desc: string;
    machine: Machine;
    createdAt: Date;
    solved: boolean;

    constructor() {
        this.idstatus = 0;
        this.cod_status = 0;
        this.notification_code = 0;
        this.notification_desc = '';
        this.machine = new Machine()
        this.createdAt = new Date()
        this.solved = false
    }
}
